import { useLanguage } from "@/i18n/LanguageContext";
import { Mic, MicOff, Activity } from "lucide-react";

export function StatusBadge({ connectionStatus }) {
  const { t } = useLanguage();
  
  const statusConfig = {
    idle: { class: "status-idle", text: t("statusIdle"), icon: MicOff },
    connecting: { class: "status-badge bg-yellow-500/20 text-yellow-400", text: t("statusConnecting"), icon: Activity },
    connected: { class: "status-recording recording-indicator", text: t("statusRecording"), icon: Mic },
    error: { class: "status-badge bg-red-500/20 text-red-400", text: t("statusError"), icon: MicOff },
  };

  const config = statusConfig[connectionStatus];
  const Icon = config.icon;

  return (
    <div className={`status-badge ${config.class}`} data-testid="status-badge">
      <Icon className="w-4 h-4" />
      <span>{config.text}</span>
    </div>
  );
}
